import React from "react";
import { GoogleMap as GoogleMapComponent, LoadScript, Marker } from '@react-google-maps/api';

export default function GoogleMap() {
    const defaultProps = {
        center: {
            lat: 47.05421829223633,
            lng: 21.9290714263916
        },
        zoom: 15,
    };

    const containerStyle = {
        width: '100%',
        height: '100%'
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
                <GoogleMapComponent
                    mapContainerStyle={containerStyle}
                    center={defaultProps.center}
                    zoom={defaultProps.zoom}
                >
                    <Marker
                        position={defaultProps.center}
                        title="My Marker"
                    />
                </GoogleMapComponent>
            </LoadScript>
        </div>
    );
}
